<section class="hero is-info is-small">
  <div class="hero-body">
    <div class="container">
      <h1 class="title"><span class="icon-text"><span class="icon"><i class="fa-solid fa-question"
              aria-hidden="true"></i></span><span>About</span></span></h1>
    </div>
  </div>
</section>
<section class="section container">
  <p>The SmallCategories Project produces, maintains, and publishes a database of small finite categories.</p>
  <p>The <a href="https://github.com/diracdeltafunk/SmallCategories"><span class="icon-text"><span class="icon"><i
            class="fa-brands fa-github" aria-hidden="true"></i></span><span>database source and
          generator</span></span></a> are public.</p>
  <p>Every property shown for a category is precomputed from its multiplication table. This site is statically generated
    and from these precomputed data, and queries are run in the browser.</p>
  <p>SmallCategories is a project by <a href="https://benspitz.com">Ben Spitz</a>. Contributions are welcome.</p>
</section>